module.exports = __webpack_public_path__ + "static/media/logo.9a41f3a9.png";